import React from "react";
import './PlayerActions.css';
import { useAbilityStore, usePlayerStore } from "../../store/store";

function PlayerActions({displayModal, sendMessage}) {

    const setShow = useAbilityStore((state) => state.setShow);
    const statPoints = usePlayerStore((state) => state.statPoints);

    const action = () => {
        sendMessage('600/trainstats');
        displayModal('trainstats');
    }

    const showStats = () => {
        sendMessage('600/stats');
    }

    const showAbilities = () => {
        sendMessage('600/alist');
    }

    const showInventory = () => {
        displayModal('inventory');
    }

    const openHotkeyEditor = () => {
        displayModal({ type: 'hotkey', initialSet: 0 });
    }

    return (
        <div className="selector">
            <button className="action" onClick={action}>Train Stats
               {statPoints > 0 &&  <span> (<span className="noOfPoints">{statPoints}</span>)</span>}
                 </button>
            <button className="action" onClick={showInventory}>Inventory</button>
            <button className="action" onClick={showAbilities}>Abilities</button>
            <button className="action" onClick={showStats}>Show Stats</button>
        </div>
    )
}

export default PlayerActions;